import axios from 'axios'
import * as _ from "lodash"
import {Am5Settings} from "@/mixins/am5charts/Am5Settings";

const REPLACE = 0
const PREPEND = 1
const APPEND = 2

const LOADING_STATUS = {
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
}

export const Am5SeriesDataLoader = class {
    constructor(series) {
        this.create(series)
    }

    addInterval(start, end, addMode = REPLACE, useUTC = false) {
        this.intervalsToLoad.push({
            start: _.clone(start),
            end: _.clone(end),
            append: false,
            addMode: addMode,
            useUTC: useUTC,
            isLoading: LOADING_STATUS.NOT_STARTED,
        })

        if (this.series.isVisible() && !this.running) {
            this.start()
        }
    }

    loadData(interval) {
        let start = _.isNil(interval.start) ? this.series.start : interval.start
        let end = _.isNil(interval.end) ? this.series.end : interval.end

        this.intervalsToLoad[0].isLoading = LOADING_STATUS.IN_PROGRESS

        console.time(`Load Series Data: ${this.series.id} - ${start.toISOString()} - ${end.toISOString()}`)
        axios.get(`/api-internal/${this.series.company}/data-meter/${this.series.id}`, {
            params: {
                startDate: start.toISOString(),
                endDate: end.toISOString(),
                requestNumber: this.requestNumber,
                useUTC: interval.useUTC,
            }
        }).then(response => {
            console.timeLog(`Load Series Data: ${this.series.id}`, 'First Response')

            let responseData = response.data
            if (responseData.requestNumber != this.requestNumber) {
                console.log(`Request Number Mismatch: Response: ${responseData.requestNumber} !== Request: ${this.requestNumber}`)
                return
            }

            this.requestNumber++
            let data = responseData.data

            this.series.setPointData(data, interval.addMode)
        }).catch(error => {
        }).then(() => {
            if (!_.isNil(this.series.sideAxis)) {
                this.series.sideAxis.updateMinMax()
            }

            if (!_.isNil(Am5Settings.updateVueHook)) {
                Am5Settings.updateVueHook()
            }
            console.timeEnd(`Load Series Data: ${this.series.id}`, 'First Response')

            this.intervalsToLoad[0].isLoading = LOADING_STATUS.COMPLETED
        })
    }

    logLoadedInterval(start, end) {
        this.loadedIntervals.push({
            start: start,
            end: end,
        })
    }

    async startLooping() {
        while (this.running) {
            if (this.intervalsToLoad.length === 0) {
                if (!_.isNil(Am5Settings.updateVueHook)) {
                    Am5Settings.updateVueHook()
                }
                this.stop()
                continue
            }

            this.run()
            await this.sleep(200)
        }
    }

    run() {
        let interval = this.intervalsToLoad[0]
        if (_.isNil(interval)) {
            this.intervalsToLoad.shift()
            return
        }

        if (interval.isLoading === LOADING_STATUS.IN_PROGRESS) {
            return
        }

        if (interval.isLoading === LOADING_STATUS.COMPLETED) {
            this.intervalsToLoad.shift()
            return
        }

        if (interval.isLoading === LOADING_STATUS.NOT_STARTED) {
            this.intervalsToLoad[0].isLoading = LOADING_STATUS.IN_PROGRESS
            this.loadData(interval)
        }
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    start() {
        this.running = true
        this.startLooping().then()
    }

    stop() {
        this.running = false
    }

    reset() {
        this.intervalsToLoad = []
        this.loadedIntervals = []
        this.requestNumber = 0
        this.running = false
    }

    clear() {
        this.intervalsToLoad = []
        this.loadedIntervals = []
        this.requestNumber = 0
    }

    clearQueue() {
        this.intervalsToLoad = []
    }

    create(series) {
        this.series = series
        this.reset()
    }
}
